import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { IconName } from '@thiememeulenhoff/types';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { label, tag } from './label.styles';
import { LabelSize, LabelVariant } from './label.types';

@customElement(tag)
export class LabelComponent extends TmElement {
  static override styles = [label];

  @property({ type: String, reflect: true })
  icon?: IconName;

  @property({ type: Number, reflect: true, attribute: 'icon-scale' })
  iconScale = 1;

  @property({ type: String, reflect: true })
  variant: LabelVariant = 'neutral';

  @property({ type: String, reflect: true })
  size: LabelSize = 'medium';

  @property({ type: Boolean, reflect: true, attribute: 'disable-border' })
  disableBorder = false;

  protected iconTemplate() {
    return html`<a-icon
      name=${this.icon}
      style="scale: ${this.iconScale}"
    ></a-icon>`;
  }

  protected override render() {
    return html`${this.icon ? this.iconTemplate() : nothing}<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-label': LabelComponent;
  }
}
